import { render, staticRenderFns } from "./accommodationActions.vue?vue&type=template&id=b31d3ea6&scoped=true"
import script from "./accommodationActions.vue?vue&type=script&lang=js"
export * from "./accommodationActions.vue?vue&type=script&lang=js"
import style0 from "./accommodationActions.vue?vue&type=style&index=0&id=b31d3ea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31d3ea6",
  null
  
)

export default component.exports